import gql from 'graphql-tag';

export default gql`
  query getItemsInSameProductFamily($itemUuid: String!) {
    getItemsInSameProductFamily(itemUuid: $itemUuid) {
      data {
        id
        supplierInternalCode
        vat
        uom
        uomLocal
        price
        originalPrice
        inStock
        name
        baseUnit
        baseUom
        netUom
        netUnit
        netUomPrice
        baseUomPrice
        savingAmount
        priceV2 {
          price
          originalPrice
          vat
          vatIncluded
        }
      }
    }
  }
`;
